"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var MarkerPin = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "marker-pin" },
            react_1.default.createElement("path", { id: "Icon", d: "M12 22L11.2929 22.7071C11.6834 23.0976 12.3166 23.0976 12.7071 22.7071L12 22ZM14 10C14 11.1046 13.1046 12 12 12V14C14.2091 14 16 12.2091 16 10H14ZM12 12C10.8954 12 10 11.1046 10 10H8C8 12.2091 9.79086 14 12 14V12ZM10 10C10 8.89543 10.8954 8 12 8V6C9.79086 6 8 7.79086 8 10H10ZM12 8C13.1046 8 14 8.89543 14 10H16C16 7.79086 14.2091 6 12 6V8ZM19 10C19 11.8921 18.1468 13.678 16.7077 15.5467C15.2588 17.4281 13.3261 19.2597 11.2929 21.2929L12.7071 22.7071C14.6739 20.7403 16.7412 18.781 18.2923 16.767C19.8532 14.7402 21 12.5262 21 10H19ZM12.7071 21.2929C10.6739 19.2597 8.74122 17.4281 7.29228 15.5467C5.85317 13.678 5 11.8921 5 10H3C3 12.5262 4.14683 14.7402 5.70772 16.767C7.25878 18.781 9.32611 20.7403 11.2929 22.7071L12.7071 21.2929ZM5 10C5 6.13401 8.13401 3 12 3V1C7.02944 1 3 5.02944 3 10H5ZM12 3C15.866 3 19 6.13401 19 10H21C21 5.02944 16.9706 1 12 1V3Z" }))));
};
exports.default = MarkerPin;
